import React from "react";
import { Tabs, Button, Modal, Input } from "antd";
import moment from "moment"
import axios from "axios"
import _, { times } from "lodash";
import "./Reservation.scss";

const _schedule = [
  [ // Sunday
    { time: "9:30 - 10:20", class: null, type: null },
    { time: "10:30 - 11:30", class: null, type: null },
    { time: "12:00 - 12:45", class: null, type: null },
    { time: "13:00 - 13:45", class: null, type: null },
    { time: "16:30 - 17:45", class: "Senior over 40, girls and couples BJJ", type: "bjj" },
    { time: "20:00 - 21:00", class: null, type: null },
    { time: "21:00 - 22:00", class: null, type: null },
  ],
  [ // Monday
    { time: "9:30 - 10:20", class: "BJJ", type: "bjj" },
    { time: "10:30 - 11:20", class: "BJJ", type: "bjj" },
    { time: "16:30 - 17:20", class: "BJJ", type: "bjj" },
    { time: "17:30 - 18:20", class: "BJJ", type: "bjj" },
    { time: "18:30 - 19:20", class: "Boxing", type: "box" },
    { time: "19:30 - 20:20", class: "BJJ", type: "bjj" },
    { time: "20:30 - 21:30", class: "BJJ", type: "bjj" },
  ],
  [ // Tuesday
    { time: "9:30 - 10:20", class: null, type: null },
    { time: "10:30 - 11:20", class: null, type: null },
    { time: "16:00 - 17:00", class: "Youth BJJ", type: "bjj" },
    { time: "17:15 - 18:15", class: "NO-GI BJJ", type: "nogi" },
    { time: "18:30 - 19:20", class: "Boxing", type: "box" },
    { time: "19:30 - 20:20", class: "BJJ", type: "bjj" },
    { time: "20:30 - 21:30", class: "BJJ", type: "bjj" },
  ],
  [ // Wednesday
    { time: "9:30 - 10:20", class: "BJJ", type: "bjj" },
    { time: "10:30 - 11:20", class: "BJJ", type: "bjj" },
    { time: "16:30 - 17:20", class: "BJJ White Belts", type: "bjj" },
    { time: "17:30 - 18:20", class: "BJJ White Belts", type: "bjj" },
    { time: "18:30 - 19:20", class: "Ringen", type: "ringen" },
    { time: "19:30 - 20:20", class: "BJJ Color Belts", type: "bjj" },
    { time: "20:30 - 21:30", class: "BJJ Color Belts", type: "bjj" },
  ],
  [ // Thursday
    { time: "9:30 - 10:20", class: null, type: null },
    { time: "10:30 - 11:20", class: null, type: null },
    { time: "14:45 - 16:00", class: "NO-GI BJJ", type: "nogi" },
    { time: "17:15 - 18:15", class: "Youth BJJ", type: "bjj" },
    { time: "18:30 - 19:20", class: "Boxing", type: "box" },
    { time: "19:30 - 20:20", class: "NO-GI BJJ", type: "nogi" },
    { time: "20:30 - 21:30", class: "NO-GI BJJ", type: "nogi" },
  ],
  [ // Friday
    { time: "9:30 - 10:20", class: "BJJ Sparring", type: "bjj" },
    { time: "10:30 - 11:20", class: "BJJ Sparring", type: "bjj" },
    { time: "16:00 - 16:50", class: "BJJ Fundamentals", type: "bjj" },
    { time: "17:00 - 17:50", class: "Condition/MMA", type: "mma" },
    { time: "18:00 - 19:00", class: "BJJ Sparring", type: "bjj" },
    { time: "20:00 - 21:00", class: "BJJ Sparring", type: "bjj" },
    { time: "21:00 - 22:00", class: "Thaiboxen", type: "thaibox" },
  ],
  [ // Saturday
    { time: "9:30 - 10:20", class: null, type: null },
    { time: "10:30 - 11:30", class: "NO-GI BJJ", type: "bjj" },
    { time: "12:00 - 12:45", class: "Youth BJJ", type: "bjj" },
    { time: "13:00 - 13:45", class: "Boxing", type: "box" },
    { time: "18:00 - 19:00", class: null, type: null },
    { time: "20:00 - 21:00", class: null, type: null },
    { time: "21:00 - 22:00", class: null, type: null },
  ]
]

const { TabPane } = Tabs;

const _emptyBooking = {
  time: null,
  date: moment(),
  class: {
    time: null, 
    class: null, 
    type: null,
  }
}

class Reservation extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      days: [],
      modal: false,
      diff: 0,      
      booking: _emptyBooking,
      name: '',
      saved: false,
      error: false
    };
  }
  
  componentDidMount() {
    const _days = [];
    _.range(7).map(_day => {
      _days[_day] = moment().add(_day, 'days');
    });
    this.setState({days: _days});
  }

  setDate = _e => {
    // console.log("_e", _e);
  }

  setBook = (_date, _time, _class) => {        

    const _now = moment();

    const _times = _time.split(' ');
    const _hour = _times[0].split(':');

    _date.set('hour', _hour[0])
    _date.set('minute', _hour[1])

    // console.log("_date", _date.format('MMMM Do YYYY, h:mm:ss a'));
        
    const diff = _date.diff(_now, 'hours');    

    // TODO: Open Modal
    this.setState({
      booking: {
        time: _time,
        date: _date,
        class: _class,
      },
      diff,
      modal: true
    })
    // console.log("_date", _date)
    // console.log("_time", _time)
  }

  handleOk = _e => {

    // url: `http://localhost:8050/api/lectures/index`,

    if(this.state.name !== '') {
      const _data = {
        time: this.state.booking.time,
        date: this.state.booking.date.format("YYYY-MM-DD"),
        class: this.state.booking.class.type,
        name: this.state.name
      }
      axios({
        method: "POST",
        url: `https://rga.cromasome.com/api/lectures/index`,
        headers: {
          "Content-Type": "application/json"
        },
        data: _data,
        json: true
      })
      .then(response => {
        console.log("response", response);
        if (response.status === 200) {
          if(response.data.success) {
            this.setState({ saved: true, error: false })
          }
        } else {
          this.setState({ saved: false, error: true })
        }
      })
      .catch(err => {
        this.setState({ saved: false, error: true })
      });
    }
  }

  handleCancel = _e => {
    this.setState({
      booking: _emptyBooking,
      name: '',
      modal: false,
      diff: 0,
      saved: false,
      error: false
    })
  }

  setName = _e => {
    this.setState({
      name: _e.target.value
    })
  }

  render() {

    // Match Date with array of classes
    const _offset = moment().format('e');

    return (
      <React.Fragment>
        <br />
        <h1 className="heading">Class Registration</h1>
        <h1 style={{color: "#ff0000"}}>Due to the Covid-19 restrictions, it is mandatory to register to a Class</h1>                
        <div className="classes">
          <Tabs defaultActiveKey="0" onChange={this.setDate}>
            {this.state.days.map((_day, _i) =>  (
              <TabPane tab={_day.format("dddd Do MMMM")} key={_i}>
                {_schedule[(_i + parseInt(_offset)) % 7].map((_class, _j) => (

                  <React.Fragment key={_j}>
                    {_class.class ? 
                      <Button className={`class ${_class.type}`} onClick={() => this.setBook(_day, _class.time, _class)} key={_j}>
                        <div>{_class.time} <b>{_class.class}</b></div>
                      </Button>
                    : <div key={_j} className="noclass" />
                    }
                  </React.Fragment>
                ))}
              </TabPane>
            ))}
          </Tabs>
        </div>
        <Modal
          title="Book a class"
          visible={this.state.modal}
          onOk={this.state.saved ? this.handleCancel : this.handleOk}
          onCancel={this.handleCancel}
          okText={`${this.state.saved ? "Close" : "Book Class"}`}
          okButtonProps={{
            disabled: this.state.name === '' ? true : false
          }}
        >
          {this.state.diff < 24 ? 
          <>
          {this.state.saved ? 
            <>
              <h1 style={{color: "#6F9C79"}}>{this.state.booking.class.class} Booked !</h1>
              <br/>
              <h2>
                {this.state.name} <br/>see you <br/>
                {this.state.booking.date.format('dddd Do MMMM')} {this.state.booking.time} <br/>
              </h2>
              <br/>
              <br/>
              <div style={{color: "#9C6F7D", fontSize: 12}}>
                If you need to cancel this booking, please contact Orlando before
              </div>
            </>
          :
            <>
              <h1>{this.state.booking.class.class}</h1>
              <h2>{this.state.booking.date.format('dddd Do MMMM')} {this.state.booking.time}</h2>
              <br/>
              <label>Your Name:</label>
              <div className={`${this.state.name === '' ? "has-error" : ''}`}>
                <Input 
                  onChange={this.setName} 
                  size="large" 
                  value={this.state.name} 
                />
              </div>
            </>
          }
          </>
          :
            <div>
              <h1 style={{color: '#FA4018'}}>This Booking can only be made 24 Hours before the class</h1>
              <h2>Registration will be open in {this.state.diff - 24} hours</h2>
            </div>
          }
        </Modal>        
      </React.Fragment>
    );
  }
}

export default Reservation;
